// Module
var code = "<template>\n  <require from=\"./overlay-manager.scss\"></require>\n  \n  <div class=\"overlay overlay-boxify overlay-boxify${ol.ControlID} ${ol.BgClass}\" repeat.for=\"ol of overlays\" css.bind=\"{ zIndex: ol.ZIndex }\" click.trigger=\"closeOverlayFromClick(ol.ControlID)\"></div>\n</template>\n";
// Exports
module.exports = code;